// Fecha: 11-07-2024
// CLON DE PRUEBA de @/views/Comprobantes/Comprobante_Hacienda


import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCambioCorral = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'comprobante_hacienda_prueba',
        name: 'Comprobante hacienda prueba',
        component: ViewCambioCorral,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
